import i18n from "./i18n"

export function formatRelativeDate(inputDate: Date) {
	const today = new Date()
	today.setHours(0, 0, 0, 0)
	const yesterday = new Date(today)
	yesterday.setDate(today.getDate() - 1)
	const normalizedInputDate = new Date(inputDate)
	normalizedInputDate.setHours(0, 0, 0, 0)

	if (normalizedInputDate.getTime() === today.getTime()) {
		return i18n.t("date_formatter.today", {date: formatDate(today)})
	} else if (normalizedInputDate.getTime() === yesterday.getTime()) {
		return i18n.t("date_formatter.yesterday", {date: formatDate(yesterday)})
	} else {
		return formatDateWithWeekday(normalizedInputDate)
	}
}

function formatDateWithWeekday(inputDate: Date) {
	return new Intl.DateTimeFormat(i18n.language, {
		year: "numeric",
		month: "long",
		day: "numeric",
		weekday: "long",
	}).format(inputDate)
}

export function formatDate(inputDate: Date) {
	return new Intl.DateTimeFormat(i18n.language, {
		year: "numeric",
		month: "long",
		day: "numeric",
	}).format(inputDate)
}
